module.exports = __webpack_public_path__ + "img/0041.a3bf0fe3.jpg";